import type { FileWithLatestFileVersion } from "schemas/generated/file";

import { skipToken } from "@tanstack/react-query";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { nextJSProjectRouter } from "@v2/trpc/routes/nextJSProject";
import { useParams, useSearchParams } from "react-router-dom";

/**
 * Hook to get the current page from the URL and fetch its data from the database.
 * Returns the page object if there's a pageId in the URL, otherwise returns null.
 *
 * @returns The current page object or null/undefined if no page is selected or data is loading
 */
export function useCurrentFile(): FileWithLatestFileVersion | null | undefined {
  const { pageId: pageIdFromRoute } = useParams<{ pageId: string }>();
  const [searchParams] = useSearchParams();
  const pageIdFromSearchParams = searchParams.get("pageId");
  const projectId = useCurrentProjectId();

  // NOTE (Cole, 2025-08-04): We do this to support the old URL format, can remove when we delete it
  const pageId = pageIdFromRoute ?? pageIdFromSearchParams;

  const { data: file } = nextJSProjectRouter.getPage.useQuery(
    pageId && projectId
      ? {
          projectId,
          id: pageId,
        }
      : skipToken,
  );

  return file;
}
